<template>
    <div class="bottom-operate-wrap">
        <Checkbox name="allCheckBox" class="all-check" @valueChange="allCheckHandler" :data="allCheck"/>
        <label class="all-label" for="allCheckBox">{{allLabel}}</label>
        <Button :text="deleteBtn" :icon="deleteIcon" @btnClick="deleteHandler"></Button>
    </div>
</template>

<script>
import Checkbox from "@/views/zhiji/bComponents/checks/Checkbox";
import Button from "@/views/zhiji/bComponents/buttons/Button";
import { STATIC_IMG_PATH } from "@/views/zhiji/js/common/constants.js";

export default {
    name: "BottomOperateBar",
    props: ["allCheck"],
    components: {
        Checkbox,
        Button
    },
    data() {
        return {
            deleteIcon: "url(" + STATIC_IMG_PATH + "class-spr.png) no-repeat -94px 0px",
        }
    },
    computed: {
        allLabel() {
            return this.$t("zhiji.common.selectAll");
        },
        deleteBtn() {
            return this.$t("zhiji.common.delete");
        }
    },
    methods: {
        allCheckHandler(data) {
            this.$emit("allCheckChange", data);
        },
        deleteHandler(e) {
            this.$emit('deleteClick', e);
        },
    }
}
</script>

<style scoped lang="scss">
    .bottom-operate-wrap {
        position: absolute;
        left: 24px;
        display: inline-flex;
        align-items: center;
        .all-check {
            margin-right: 10px;
        }
        .all-label {
            margin-right: 16px;
        }
    }
</style>